import { Component, Input, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  standalone: true,
  selector: 'ain-search-accordion',
  imports: [ButtonModule],
  template: `
    <section class="search-accordion">
      <button pButton type="button" class="toggle" [text]="true" (click)="toggle()">
        {{ title }}
        <span>{{ expanded() ? '−' : '+' }}</span>
      </button>
      @if (expanded()) {
        <div class="content">
          <ng-content />
        </div>
      }
    </section>
  `,
  styles: [`
    .search-accordion { border: 1px solid #e2e8f0; border-radius: 12px; margin-bottom: 12px; background: #fff; }
    .toggle { width: 100%; justify-content: space-between; padding: 10px 12px; border-bottom: 1px solid #f1f5f9; border-radius: 12px 12px 0 0; }
    .content { padding: 12px; display: grid; gap: 10px; }
  `]
})
export class AinSearchAccordionComponent {
  @Input() title = 'Search';
  readonly expanded = signal(false);

  toggle(): void {
    this.expanded.update(value => !value);
  }
}
